(function() {
    'use strict';

    let downloadButtons = document.querySelectorAll('.js-btn-download-attachment-file');

    init();

    function init() {
        bindHandlers();
    }

    function bindHandlers() {
        if (!downloadButtons) {
            return;
        }

        [].forEach.call(downloadButtons, (button) => {
            button.addEventListener('click', onButtonDownloadClick);
        });
    }

    function onButtonDownloadClick(evt) {
        let url = evt.currentTarget.getAttribute('data-url-log-download');
        let code = evt.currentTarget.getAttribute('data-code');
        let fileDescription = evt.currentTarget.getAttribute('data-file-description');
        let formData = new FormData();

        formData.append('code', code);
        formData.append('fileDescription', fileDescription);

        ajax(url, formData);
    }

    function ajax(url, formData) {
        let request = new XMLHttpRequest();

        request.open('POST', url, true);
        request.send(formData);
    }
}());

